import { Vehicle } from "@/config/types/Planning";
export const getPathKey = (): string => {
    const path = window.location.pathname;
    const parts = path.split('/');
    const key = parts[parts.length - 1];
  
    return key && key !== 'undefined' ? key : '';
  };

export function getLoadClassData(filteredVehicle: Vehicle | null): string | null {
  if (!filteredVehicle) return null;
  if (filteredVehicle.load_class_name && filteredVehicle.load_class_name !== "DEFAULT") {
    return filteredVehicle.load_class_name;
  }
  return null;
}